import React from "react";

import { IconProps } from "../../types/common";

import ArrowRight from "./ArrowRight";

const ArrowUp = ({ style = {}, ...otherProps }: IconProps) => (
  <ArrowRight
    style={{
      ...style,
      transform: "rotate(-90deg)",
    }}
    {...otherProps}
  />
);

export default ArrowUp;
